import React, { useEffect, useState, useRef } from "react";
import Loading from "./loading.js";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);

const Login = (props) => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(true);

  const handleLoginChange = (e) => {
    setLogin(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const checkLoginData = async () => {
    setLoading(true);
    var body = {
      login: login,
      password: password,
    };

    await fetch("https://apisplit.ftpeople.pl/getLoginData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.length > 0) {
          props.login(data);
        } else {
          MySwal.fire({
            icon: "error",
            title: "Błąd",
            text: "Nieprawidłowe dane logowania",
          }).then(() => {
            setLoading(false);
          });
        }
      })
      .catch((error) => {});
  };

  const handleLogin = (e) => {
    checkLoginData();
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="mainContainerLoginPage">
          <div style={{ width: "100%" }}>
            <img src="https://ftpeople.pl/wp-content/uploads/2024/02/logoftp.png" />
          </div>

          <div style={{ display: "block", height: "100%" }}>
            <div style={{ width: "100%", display: "block" }}>
              <p className="defaultLabel">Login</p>
              <input
                type="text"
                id="login"
                name="login"
                value={login}
                onChange={handleLoginChange}
              />
            </div>
            <div>
              <p className="defaultLabel">Hasło</p>
              <input
                type="password"
                id="password"
                name="password"
                value={password}
                onChange={handlePasswordChange}
              />
            </div>
            <div>
              <button
                className="loginButtonLogin"
                value="yes"
                onClick={handleLogin}
              >
                ZALOGUJ
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
